// extracted by mini-css-extract-plugin
module.exports = {"button_wrapper":"social-media-button_button_wrapper__5lEA6","image_wrapper":"social-media-button_image_wrapper__iZkE8","social_title":"social-media-button_social_title__G1rBj"};